
import { getCategoriesList } from '@/service/common'
import { Component, Vue } from 'vue-property-decorator'
import CategoriesDetail from './CategoriesDetail.vue'
@Component({
  components: {
    CategoriesDetail,
  },
})
export default class Categories extends Vue {
  categoriesList = []
  currentCategories = {}
  showDetail = false
  created() {
    this.getCategories()
  }
  async getCategories() {
    try {
      this.categoriesList = await getCategoriesList()
    } catch (err) {
      console.error(err)
    }
  }
  onClickCategories(categories: any) {
    this.currentCategories = categories
    this.showDetail = true
  }
}
